import React from "react";
import "./App.css";
// import { createStore } from "redux";
// import rootReducer from "./store/reducer/rootReducer";
import { Provider, useSelector } from "react-redux";
// import { persistStore, persistReducer } from "redux-persist";
// import { PersistGate } from "redux-persist/integration/react";
// import createEncryptor from "redux-persist-transform-encrypt";
// import localStorage from "redux-persist/es/storage";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./themes/darktheme.css";
import './assets/css/font-awesome/css/font-awesome.min.css';
import SignIn from "./components/SignIn/SignIn";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import SignInSparsh from "./components/SignIn/SignInSparsh";
import RouteWithPlant from "./routes/RouteWithPlant";
// import RouteWithPlant from "./routes/RouteWithPlant";

const ModRouter = React.lazy(() => import("./routes/ModRouter"));


function App() {
  const isAuth = useSelector((state) => state.isAuth);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

  return (
    // <Provider store={store}>
    //   <PersistGate loading={null} persistor={persistor}>
    <Router>
      <Switch>
        <Route exact path="/new-login/:plantName" component={SignIn} />
        <Route exact path="/v02/:urlCode/sparsh" component={SignInSparsh} />
        {!isAuth ? (
          <>
          <Route path="/" component={RouteWithPlant} />
            {/* <Route exact path="/v02/:urlCode/login" component={SignIn} /> */}
            {/* <Route exact path="/" component={SignIn} /> */}
            {/* <Redirect from="*" to={`/v02/${localStorage.getItem('urlCode') || 'uc'}/login`} /> */}
          </>
        ) : (
          <>
            <React.Suspense
              fallback={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                  }}
                >
                  <Spin indicator={antIcon} />
                </div>
              }
            >
              <Route path="/" component={RouteWithPlant} />
              {/* <ModRouter /> */}
            </React.Suspense>
          </>
        )}
      </Switch>
    </Router>
    //   </PersistGate>
    // </Provider>
  );
}

export default App;
